export const HOME_PATH = "/home"
export const CUSTOMERS_BASE_PATH = "/customers"
export const LOGIN_PATH = "/login"
export const LOGOUT_PATH = "/logout"
export const ADMIN_PATH = "/admin"
